import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Link } from 'DVWebNodeUI'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { tryCatch } from '../../utils/tryCatch'
import * as utilityClasses from '../utilityClasses.module.scss'
import * as st from './btfMorePurchaseOptions.module.scss'
import { ModalTrigger } from '../../utils/ModalTrigger'
import { MwtwModal } from '../acquisition/moreWaysToWatchModal'

//TODO: Move to selector once btf using them
export const shouldShowMoreWaysToWatch = (
  moreWaysToWatch?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
) => {
  if (!moreWaysToWatch) {
    return false
  }

  return (
    (
      (moreWaysToWatch as
        | WpsRuntime.atv.wps.AcquisitionActionTreeRightProps
        | WpsRuntime.atv.wps.AcquisitionActionTreeLeftProps).children || []
    ).length > 0
  )
}

export interface IBTFMorePurchaseOptionProps {
  sequenceNumber?: number
  moreWaysToWatch?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
  titleId?: string
  openGiftCardModal?: () => void
}

export const BtfMorePurchaseOptions = tryCatch(
  ({
    moreWaysToWatch,
    sequenceNumber,
    titleId,
    openGiftCardModal
  }: IBTFMorePurchaseOptionProps) => {
    if (!shouldShowMoreWaysToWatch(moreWaysToWatch) || !titleId) {
      return null
    }

    return (
      <div className={utilityClasses.stretchHeight}>
        <ModalTrigger
          modalId="dvui-close-overlay-btf-mwtw"
          modalContent={({ closeModal }) => (
            <MwtwModal
              closeModal={closeModal}
              moreWaysToWatch={moreWaysToWatch}
              sequenceNumber={sequenceNumber}
              openGiftCardModal={openGiftCardModal}
            />
          )}
          toggle={({ openModalClickHandler }) => (
            <Link
              className={st.trigger}
              data-ux-click
              onClick={openModalClickHandler}
            >
              <TextLocalizer stringID={StringId.DV_MWTW_TITLE} />
            </Link>
          )}
        />
      </div>
    )
  }
)
